import { useMe } from '../me/MeProvider';

/**
 * @typedef {Object} PermissionQuery
 * @property {string[]} [perms]   AND — alle müssen vorhanden sein
 * @property {string[]} [anyOf]   OR  — mindestens eine muss vorhanden sein
 */

/** @param {PermissionQuery} query */
export function useHasPermission({ perms, anyOf } = {}) {
  const { permissions } = useMe();
  return matchPermissions(permissions, { perms, anyOf });
}

export function matchPermissions(granted, { perms, anyOf } = {}) {
  if (perms?.length && !perms.every((p) => granted.includes(p))) return false;
  if (anyOf?.length && !anyOf.some((p) => granted.includes(p))) return false;
  return true;
}
